if (!customElements.get("m-announcement-bar")) {
  class MAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.displayText = this.parentElement.querySelector(".m-announcement-bar__display-text");
      this.displayLink = this.parentElement.querySelector(".m-announcement-bar__display-link");

      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider) {
        this.syncDisplayToSlide(this.querySelector(".m-announcement-bar__item"));
        return;
      }
      this.initSlider();
    }

    // Reads whichever message is currently "active" (from Swiper if a
    // carousel is running, or the single item if there's just one message)
    // and mirrors its text/link into our own independent, safely-centered
    // display element — which Swiper never touches and can't interfere with.
    syncDisplayToSlide(slideEl) {
      if (!slideEl || !this.displayText) return;
      const content = slideEl.querySelector(".m-announcement-bar__content");
      const link = slideEl.querySelector(".m-announcement-bar__link");
      this.displayText.textContent = content ? content.textContent.trim() : "";
      if (link && link.getAttribute("href")) {
        this.displayLink.href = link.getAttribute("href");
        this.displayLink.style.display = "";
        this.displayLink.appendChild(this.displayText);
      } else if (this.displayLink && this.displayLink.contains(this.displayText)) {
        this.displayLink.style.display = "none";
        this.parentElement.querySelector(".m-announcement-bar__display").appendChild(this.displayText);
      }
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const slideContainer = this.querySelector(".swiper-container");
      if (slideContainer) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          centeredSlides: true,
          autoplay: autoplay
            ? {
                delay: parseInt(autoplaySpeed) * 1000,
              }
            : false,
          loop: true,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
          on: {
            init: (swiper) => {
              const activeSlide = swiper.slides[swiper.activeIndex];
              this.syncDisplayToSlide(activeSlide);
            },
            slideChange: (swiper) => {
              const activeSlide = swiper.slides[swiper.activeIndex];
              this.syncDisplayToSlide(activeSlide);
            },
          },
        });
      }
    }
  }

  customElements.define("m-announcement-bar", MAnnouncementBar);
}